var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 481,
    viewBox: "0 0 336 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.348 210.779L-23.985 4.883a34.416 34.416 0 00-34.574-.446C-69.339 10.543-76 21.932-76 34.282v411.724a34.362 34.362 0 0017.407 29.88c5.287 2.95 11.09 4.425 16.926 4.425 6.112 0 12.257-1.612 17.682-4.871l343.333-205.828A34.306 34.306 0 00336 240.178a34.291 34.291 0 00-16.652-29.399z",
    fill: "url(#bg-triangle_svg__paint0_linear_3894_103841)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-triangle_svg__paint0_linear_3894_103841",
    x1: 22.838,
    y1: 23.231,
    x2: 348.149,
    y2: 166.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBFE"
  })))));
}

export default "data:image/svg+xml,%3Csvg width='336' height='481' viewBox='0 0 336 481' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M319.348 210.779L-23.985 4.88271C-34.594 -1.46365 -47.778 -1.63516 -58.5587 4.43676C-69.3393 10.543 -76 21.9321 -76 34.2818V446.006C-76 458.39 -69.3393 469.779 -58.593 475.886C-53.3057 478.836 -47.5033 480.311 -41.6667 480.311C-35.5553 480.311 -29.4097 478.699 -23.985 475.44L319.348 269.612C329.683 263.403 336 252.254 336 240.178C336 228.137 329.683 216.988 319.348 210.779Z' fill='url(%23paint0_linear_3894_103841)'/%3E %3Cdefs%3E %3ClinearGradient id='paint0_linear_3894_103841' x1='22.8381' y1='23.2309' x2='348.149' y2='166.795' gradientUnits='userSpaceOnUse'%3E %3Cstop stop-color='%23EBEBFE' stop-opacity='0'/%3E %3Cstop offset='1' stop-color='%23EBEBFE'/%3E %3C/linearGradient%3E %3C/defs%3E %3C/svg%3E";
export { SvgBgTriangle as ReactComponent };